import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { buildContextUrl } from '../../routing/contextUrl';

import './DeeplinkAccessDenied.scss';

/**
 * Full-screen, explicit message shown when a shared link points at an instance
 * or edition the current user cannot access.
 */
const DeeplinkAccessDenied = ({ reason, slug, editionId, currentInstanceName, currentSlug }) => {
    const { t } = useTranslation();

    const title = reason === 'edition'
        ? t('context.denied.edition_title')
        : t('context.denied.instance_title');

    const message = reason === 'edition'
        ? t('context.denied.edition_message', { edition: editionId })
        : t('context.denied.instance_message', { slug });

    const goToOwnInstance = () => {
        if (!currentSlug) {
            window.location.assign('/');
            return;
        }
        window.location.assign(buildContextUrl({ slug: currentSlug, editionId: null }, '/'));
    };

    return (
        <div className="DeeplinkAccessDenied">
            <div className="DeeplinkAccessDenied__card">
                <i className="fa fa-lock DeeplinkAccessDenied__icon" aria-hidden="true" />
                <h1 className="DeeplinkAccessDenied__title">{title}</h1>
                <p className="DeeplinkAccessDenied__message">{message}</p>
                {currentInstanceName && (
                    <p className="DeeplinkAccessDenied__current">
                        {t('context.denied.current_instance', { name: currentInstanceName })}
                    </p>
                )}
                <div className="DeeplinkAccessDenied__actions">
                    <Button color="primary" onClick={goToOwnInstance}>
                        {t('context.denied.go_to_my_instance')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DeeplinkAccessDenied;
